<template>
  <div id="serve">
    <pre style="text-align:center;padding:20px 0;">用户服务条款

用户服务协议

重要提示：

Fancy-Music网站（）由首秀网络科技（杭州）有限公司（以下简称“首秀网络科技”）运营。本协议有用户（以下简称“您”或“用户”）与首秀网络科技共同缔结。

在您使用首秀网络科技服务之前，您应当认真阅读并遵守《用户服务协议》（以下简称“本协议”），在此特别提醒您认真阅读、充分理解本协议各条款，特别是其中所涉及的免除及限制责任的条款、对用户权利限制条款等。

当您按照首秀网络科技页面提示填写信息、阅读并同意本协议后，或您以首秀网络科技允许的方式实际使用本服务时，即表示您已充分阅读、理解并接受本协议的全部内容，本协议即产生法律约束力。您承诺接受并遵守本协议的约定，届时您不应以未阅读本协议的内容等理由，主张本协议无效，或要求撤销本协议。

一、服务内容

1. 首秀网络科技提供各种形式服务软件（具体以首秀网络科技提供的为准），首秀网络科技不断丰富您使用本服务的终端、形式等。

2. 本服务内容可能根据用户需求的变化，随着因服务版本不同、或服务提供方的单方判断而被优化或修改，或因定期、不定期的维护而暂缓提供。

3. 同时，首秀网络科技保留在任何时候自行决定对服务或服务任何部分及其相关功能、应用软件变更、升级、修改、转移的权利。您同意，对于上述行为，首秀网络科技不需通知，并且对您和任何第三人不承担任何责任。

二、协议内容和效力

1. 本协议内容包括本协议正文、首秀网络科技与用户或用户所属机构另行签署的书面协议（如有）及所有首秀网络科技已经发布或将来可能发布的隐私政策、各项政策、规则、声明、通知、警示、提示、说明（以下简称“规则”）。前述规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。

2. 首秀网络科技有权根据需要不时制订、修改本协议及相关规则，变更后的协议和规则一经公布，立即取代原协议及规则并自动生效。如您不同意相关变更，应当立即停止使用首秀网络科技服务平台服务，如您继续使用首秀网络科技服务平台服务或进行任何网站活动，即表示您已接受经修订的协议和规则。

3. 本协议效力及于首秀网络科技（杭州）有限公司及现有和/或未来设立的相关关联公司。

三、用户及账号管理

1. 您确认，在您完成注册程序或以其他首秀网络科技允许的方式实际使用服务时，您应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请勿使用服务，否则您及您的监护人应承担因此而导致的一切后果，且首秀网络科技有权注销（永久冻结）您的账户，并向您及您的监护人索偿。

2. 您可以使用您提供或确认的手机号或者首秀网络科技允许的其它方式作为用户账号进行注册。同时您应当按照法律法规和服务要求，按相应页面的提示准确提供并及时更新您的资料，以使之真实、及时，完整和准确。如因用户未及时更新基本资料，导致首秀网络科技服务平台服务无法提供或提供时发生任何错误，首秀网络科技亦不承担任何责任，所有后果应由用户承担。您承诺不得注册一个以上首秀网络科技服务平台账号、不得冒充他人进行注册、不得未经许可为他人注册、不得以可能导致其他用户误认的方式注册账号，不得使用可能侵犯他人权益的用户名进行注册（包括但不限于涉嫌商标权、名誉权侵权等），否则首秀网络科技有权取消该账号，并有权要求用户赔偿其损失。

3. 您了解并同意，首秀网络科技服务平台注册账号所有权归属于首秀网络科技，注册完成后，您仅获得账号使用权。除非有法律规定或司法裁定，且征得首秀网络科技的同意，否则，您的账户、密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。否则，首秀网络科技有权立即不经通知收回该账号，由此带来的因您使用本服务产生的全部数据、信息等被清空、丢失等的损失，您应自行承担。

4. 在您成功注册后，首秀网络科技将根据账号和密码确认您的身份。您应妥善保管您的终端及账户和密码，并对利用该账户和密码所进行的一切活动负全部责任。您承诺，在密码或账户遭到未获授权的使用，或者发生其他任何安全问题时，将立即通知首秀网络科技，且您同意并确认，首秀网络科技不对上述情形产生的任何直接或间接的遗失或损害承担责任。

5. 首秀网络科技根据本协议收回或取消账号后，有权自行对账号相关内容及信息以包括但不限于删除等方式进行处理，且无需就此向用户承担任何责任。

6. 首秀网络科技有权基于单方独立判断，在其认为可能发生危害交易安全等情形时，不经通知而先行暂停、中断或终止向用户提供本协议项下的全部或部分用户的全部或部分服务，并将注册资料移除或删除，且无需对用户或任何第三方承担任何责任，并要求用户赔偿损失（如有）。前述情形包括但不限于：

（1）首秀网络科技认为用户提供的个人资料不具有真实性、有效性或完整性；

（2）首秀网络科技发现异常或有疑义或有违法之虞时；

（3）首秀网络科技认为用户已经违反本协议中规定的各类规则及精神；

（4）以首秀网络科技允许的方式使用首秀网络科技服务平台服务的用户所属机构，根据其与首秀网络科技达成的协议，终止相关合作时；

（5）首秀网络科技根据其单独判断需先行暂停、中断或终止向部分或全部用户提供本协议项下的全部或部分用户服务，并将注册资料移除或删除的其他情形。

7. 用户同意，用户账户的暂停、中断或终止不代表用户责任的终止，用户仍应对使用首秀网络科技服务平台服务期间的行为承担可能的违约或损害赔偿责任，同时首秀网络科技仍可保有用户的相关信息。

四、用户使用规范

1. 用户充分了解并同意，首秀网络科技仅为用户提供服务平台，您应自行对利用服务从事的所有行为及结果承担责任。相应地，您应了解，使用首秀网络科技服务可能发生来自他人非法或不当行为（或信息）的风险，您应自行判断及行动，并自行承担相应的风险。

2. 您承诺不会利用本服务进行任何违法或不当的活动，包括但不限于下列行为∶

2.1 上载、传送或分享含有下列内容之一的信息：

（a）反对宪法所确定的基本原则的；

（b）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；

（c）损害国家荣誉和利益的；

（d）煽动民族仇恨、民族歧视、破坏民族团结的；

（e）破坏国家宗教政策，宣扬邪教和封建迷信的；

（f）散布谣言，扰乱社会秩序，破坏社会稳定的；

（g）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；

（h）侮辱或者诽谤他人，侵害他人合法权利的；

（i）含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；

（j）含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。

2.2 将依据任何法律或合约或法定关系（例如由于雇佣关系、合作关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）知悉但无权传送之任何内容加以上载、传送或分享；

2.3 将涉嫌侵害他人权利之内容上载、传送或分享；

2.4 从事任何违反中国法律、法规、规章、政策及规范性文件的行为。

3. 您承诺不对本软件和服务从事以下行为：

3.1 将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送；

3.2 干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；

3.3 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；

3.4 通过非首秀网络科技开发、授权的第三方软件、插件、外挂、系统，登录或使用软件及服务，或制作、发布、传播上述工具；

3.5 自行、授权他人或利用第三方软件对本软件及其组件、模块、数据等进行干扰。

4. 您承诺，使用首秀网络科技服务时您将严格遵守本协议（包括本协议第二条所述规则）。

5. 您同意并接受首秀网络科技无须时时监控您上载、传送或分享的资料及信息，但首秀网络科技有权对您使用服务的情况进行审查、监督并采取相应行动，包括但不限于删除信息、中止或终止服务，及向有关机关报告。

6. 您承诺不以任何形式使用本服务侵犯首秀网络科技利益，或从事任何可能对首秀网络科技造成损害或不利于首秀网络科技的行为。

7. 您了解并同意，在首秀网络科技服务提供过程中，首秀网络科技及其关联公司或其授权单位和个人有权以各种方式投放各种商业性广告或其他任何类型的推广信息。

8. 您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对使用本服务时接触到的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。首秀网络科技无法且不会对您因前述风险而导致的任何损失或损害承担责任。

9. 您承诺您在使用首秀网络科技服务平台服务时所提交的相关数据，均已经过数据源方充分有效的授权。

10. 如果首秀网络科技发现或收到他人举报您有违反本协议约定、承诺或保证的，首秀网络科技权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于收回账号，限制、暂停、终止您使用部分或全部本服务，追究法律责任等措施。

11. 用户同意，由于用户违反本协议，或违反通过援引并入本协议并成为本协议一部分的文件，或由于用户使用首秀网络科技服务平台服务违反了任何法律或第三方的权利而造成任何第三方进行或发起的任何补偿申请或要求（包括律师费用），用户应对首秀网络科技及其关联方、合作伙伴给予全额补偿并使之不受损害。

五、第三方应用

1. 首秀网络科技不对任何用户及/或任何交易提供任何担保或条件，无论是明示、默示或法定的。首秀网络科技不能也不试图对用户发布的信息进行控制，对该等信息，首秀网络科技不承担任何形式的证明、鉴定服务。首秀网络科技不能完全保证平台内容的真实性、充分性、可靠性、准确性、完整性和有效性，并且无需承担任何由此引起的法律责任。用户依赖于用户的独立判断进行交易，用户应对其作出的判断承担全部责任。

2. 首秀网络科技未对任何首秀网络科技服务平台服务提供任何形式的保证，包括但不限于以下事项：

（1）首秀网络科技服务平台服务将符合用户的需求。

（2）首秀网络科技服务平台服务将不受干扰、及时提供或免于出错。

（3）用户经由首秀网络科技服务平台服务购买或取得之任何产品、服务、资讯或其他资料将符合用户的期望。

3. 用户自首秀网络科技及首秀网络科技工作人员或经由首秀网络科技服务平台服务取得的建议或资讯，无论其为书面或口头，均不构成首秀网络科技对首秀网络科技服务平台服务的任何保证。

4. 用户同意，基于互联网的特殊性，首秀网络科技不担保服务不会中断，也不担保服务的及时性和/或安全性。系统因相关状况无法正常运作，使用户无法使用任何首秀网络科技服务平台服务或使用任何首秀网络科技服务平台服务时受到任何影响时，首秀网络科技对用户或第三方不负任何责任，前述状况包括但不限于：

（1）首秀网络科技系统停机维护期间。

（2）电信设备出现故障不能进行数据传输的。

（3）由于黑客攻击、网络供应商技术调整或故障、网站升级、银行方面的问题等原因而造成的首秀网络科技服务平台服务中断或延迟。

（4）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成首秀网络科技系统障碍不能执行业务的。

5. 以上并不能揭示用户通过使用首秀网络科技的全部风险。用户在做出交易决策前，应全面了解相关交易，谨慎决策，并自行承担全部风险。

六、知识产权的保护

1. 非经首秀网络科技或其他权利人书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表首秀网络科技平台程序或内容。

2. 用户不得对首秀网络科技服务平台或其内容进行转售或商业利用；不得对首秀网络科技服务平台或其内容进行任何衍生利用；不得为其他商业利益而下载或拷贝账户信息或使用任何数据采集、Robots或类似的数据收集和摘录工具。未经首秀网络科技的书面许可，严禁对首秀网络科技服务平台的内容进行系统获取以直接或间接创建或编辑文集、汇编、数据库或人名地址录（无论是否通过Robots、Spiders、自动仪器或手工操作）。

4. 用户未经首秀网络科技明确书面同意，不得以任何商业目的对首秀网络科技网站或其任何部分进行复制、复印、仿造、出售、转售、访问、或以其他方式加以利用。未经首秀网络科技明确书面同意，用户不得把首秀网络科技或其关联公司的商标、标识或其他专有信息（包括图像、文字、网页设计或形式）据为己有。未经首秀网络科技明确书面同意，用户不得以任何方式使用首秀网络科技或其关联公司的名字和商标。

5. 用户应尊重知识产权是用户应尽的义务，如有违反，用户应对首秀网络科技承担损害赔偿等法律责任。

七、通知及争议解决

1. 有效通知

（1）首秀网络科技向您发出的任何通知，可采用电子邮件、页面公开区域公告、个人网络区域提示、手机短信或常规信件等方式，且该等通知应自发送之日视为已向用户送达或生效。

（2）您同意，您向首秀网络科技发出的任何通知应发至首秀网络科技服务平台对外正式公布或使用其他首秀网络科技认可的其他通知方式进行送达。

2. 争议解决

（1）本协议之解释与适用，以及与本协议有关的争议，均应依照中华人民共和国法律予以处理，并将该争议提交上海仲裁委员会，并适用杭州仲裁委员会仲裁规则项下的简易程序进行仲裁，仲裁地为杭州。

（2）如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部份则仍具有法律效力。

（3）首秀网络科技于用户过失或违约时放弃本协议规定的权利的，不得视为其对用户的其他或以后同类之过失或违约行为弃权。

（4）首秀网络科技有权根据业务调整情况将本协议项下的全部权利义务一并转移给其关联公司，转让将以本协议规定的方式通知，用户承诺对此不持有异议。</pre>
  </div>
</template>

<script>
export default {
  name:'serve'
}
</script>